// src/components/LandingSection.js
import React from "react";
import { GITHUB_URL, LINKEDIN_URL, scrollToId } from "./links";

const stats = [
  { value: "5+", label: "years full stack" },
  { value: "38", label: "CloudWatch alarms shipped" },
  { value: "10", label: "AI features on 2 models" },
  { value: "2", label: "live brands on my own platform" },
];

const LandingSection = () => (
  <section className="hero">
    <div className="glow" />
    <h1>
      Andrew Rise
      <span className="role">
        <b>Senior Full Stack Engineer</b>
      </span>
    </h1>
    <p className="sub">
      TypeScript, React/Next.js, Node/NestJS, AWS. I build production systems end to end, including AI features that
      actually ship.
    </p>
    <p className="stack mono">
      <i>&gt;</i> 5+ yrs shipping production software · founding dev at Perfecti · lead dev at RealtyOS · building ProGig
    </p>
    <div className="cta">
      <a className="btn p" href="#projects" onClick={scrollToId("projects")}>
        View projects
      </a>
      <a className="btn" href={GITHUB_URL} target="_blank" rel="noopener noreferrer">
        GitHub
      </a>
      <a className="btn" href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer">
        LinkedIn
      </a>
    </div>
    <div className="stats">
      {stats.map((s) => (
        <div className="stat" key={s.label}>
          <b>{s.value}</b>
          <span>{s.label}</span>
        </div>
      ))}
    </div>
  </section>
);

export default LandingSection;
